import {
  getProfile,
  getUpgradePackagesList,
  upgradePackage,
} from "../../../Redux/Profile/ProfileActions";
import FamilyMemberModal from "../../../Components/User/FamilyMemberModal/FamilyMemberModal";
import SelectCard from "../../../Components/User/Bookings/SelectCard/SelectCard";
import Agreement from "../../../Components/User/Bookings/Agreement/Agreement";
import { ReactComponent as TickIcon } from "../../../Assets/Tick.svg";
import React, { useEffect, useMemo, useRef, useState } from "react";
import Loading from "../../../Components/Common/Loading/Loading";
import Modal from "../../../Components/Common/Modal/Modal";
import { useDispatch, useSelector } from "react-redux";
import arrowIcon from "../../../Assets/arrowleft.png";
import SignatureCanvas from "react-signature-canvas";
import toastHelper from "../../../Util/toastHelper";
import { AppDispatch } from "../../../Redux/store";
import { RootState } from "../../../Redux/store";
import { Link, useNavigate } from "react-router";
import styles from "./Upgrade.module.scss";

interface FamilyMember {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  bookingAllowed: boolean;
}

function Upgrade() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const {
    getUpgradePackagesListLoading,
    getUpgradePackagesListData,
    upgradePackageLoading,
  } = useSelector((state: RootState) => state.profile);

  const [selectedPackage, setSelectedPackage] = useState(-1);
  const [agreementModalOpen, setAgreementModalOpen] = useState(false);
  const [selectCardModalOpen, setSelectCardModalOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState<string>("");
  const [signature, setSignature] = useState<string>("");
  const signRef = useRef<SignatureCanvas | null>(null);
  const [familyMemberModalOpen, setFamilyMemberModalOpen] = useState(false);
  const [familyMembers, setFamilyMembers] = useState<FamilyMember[]>([]);

  const upgradeHandler = () => {
    if (selectedPackage !== -1) {
      if (packageData?.isFamily) {
        setFamilyMemberModalOpen(true);
      } else {
        setAgreementModalOpen(true);
      }
    } else {
      toastHelper.error("Please select a package");
    }
  };

  const agreementHandler = () => {
    if (signRef?.current) {
      if (signRef.current.isEmpty()) {
        toastHelper.error("Please sign the agreement");
      } else {
        setSignature(signRef.current.toDataURL());
        setAgreementModalOpen(false);
        setSelectCardModalOpen(true);
      }
    }
  };

  const upgradePackageHandler = () => {
    if (selectedCard) {
      if (!upgradePackageLoading) {
        const params = {
          newPackageId: selectedPackage,
          signature: signature,
          memberCCInfoId: Number(selectedCard),
          familyMember: packageData?.isFamily ? familyMembers : [],
          successHandler: () => {
            setSelectCardModalOpen(false);
            navigate("/", { replace: true });
            toastHelper.success("Package upgraded successfully");
          },
          navigate: navigate,
        };

        dispatch(upgradePackage(params));
      }
    } else {
      toastHelper.error("Please select a card");
    }
  };

  const packageData = useMemo(() => {
    if (getUpgradePackagesListData && selectedPackage !== -1) {
      return getUpgradePackagesListData?.packages?.find(
        (pack: any) => pack.packageId === selectedPackage,
      );
    }
    return null;
  }, [getUpgradePackagesListData, selectedPackage]);

  const familyMemberModalHandler = () => {
    if (familyMembers.length === 0) {
      toastHelper.error("Please add at least one member");
      return;
    }
    setFamilyMemberModalOpen(false);
    setAgreementModalOpen(true);
  };

  useEffect(() => {
    dispatch(getProfile({ navigate: navigate }));
    dispatch(getUpgradePackagesList());
  }, [dispatch]);

  console.log("packageData", packageData);

  if (getUpgradePackagesListLoading) {
    return <Loading />;
  }

  return (
    <React.Fragment>
      {upgradePackageLoading && <Loading />}
      <Modal
        isOpen={agreementModalOpen}
        setIsOpen={setAgreementModalOpen}
        showCloseIcon={false}
      >
        <Agreement
          signRef={signRef}
          termsAndConditions={getUpgradePackagesListData?.terms}
        />

        <div className={styles.proceedButtonContainer}>
          <button onClick={agreementHandler} className={styles.button}>
            Proceed
          </button>
          <button
            onClick={() => setAgreementModalOpen(false)}
            className={styles.cancelButton}
          >
            Cancel
          </button>
        </div>
      </Modal>

      <Modal
        isOpen={selectCardModalOpen}
        setIsOpen={setSelectCardModalOpen}
        showCloseIcon={false}
      >
        <SelectCard
          selectedCard={selectedCard}
          setSelectedCard={setSelectedCard}
        />

        <div className={styles.proceedButtonContainer}>
          <button onClick={upgradePackageHandler} className={styles.button}>
            Proceed
          </button>
          <button
            onClick={() => setSelectCardModalOpen(false)}
            className={styles.cancelButton}
          >
            Cancel
          </button>
        </div>
      </Modal>

      <Modal
        isOpen={familyMemberModalOpen}
        setIsOpen={setFamilyMemberModalOpen}
      >
        <FamilyMemberModal
          familyMembers={familyMembers}
          setFamilyMembers={setFamilyMembers}
          packageData={packageData}
        />
        <div className={styles.proceedButtonContainer}>
          <button onClick={familyMemberModalHandler} className={styles.button}>
            Proceed
          </button>
          <button
            onClick={() => setFamilyMemberModalOpen(false)}
            className={styles.cancelButton}
          >
            Cancel
          </button>
        </div>
      </Modal>
      <div className={styles.mainContainer}>
        <Link to="/" className={styles.backButtonContainer}>
          <button className={styles.button}>
            <img src={arrowIcon} alt="arrowIcon" className={styles.arrowIcon} />
            Back to Dashboard
          </button>
        </Link>
        <div className={styles.headingContainer}>
          <h1 className={styles.heading}>Upgrade Packages</h1>
        </div>
        <div className={styles.subHeadingContainer}>
          <p className={styles.label}>Select package</p>
        </div>
        {getUpgradePackagesListData?.packages?.length === 0 && (
          <div className={styles.noPackageContainer}>
            <p className={styles.text}>No package found</p>
          </div>
        )}
        <div className={styles.packagesContainer}>
          {getUpgradePackagesListData?.packages?.map((pack: any, i: number) => {
            return (
              <div key={i} className={styles.package}>
                <div className={styles.infoContainer}>
                  <p className={styles.name}>{pack?.packageName}</p>
                  <p className={styles.price}>${pack?.totalRates}/mo</p>
                </div>
                {
                  <div className={styles.trialContainer}>
                    {pack?.isFreeMonth && (
                      <p className={styles.label}>
                        This package has a one month free trial
                      </p>
                    )}
                  </div>
                }
                <div className={styles.buttonContainer}>
                  <button
                    className={styles.button}
                    onClick={() => setSelectedPackage(pack?.packageId)}
                  >
                    {selectedPackage === pack?.packageId
                      ? "Selected"
                      : "Select"}
                  </button>
                </div>
                <div className={styles.featuresContainer}>
                  <p>Plan includes</p>
                  {pack?.packageAmenities?.map((amenity: any, j: number) => {
                    return (
                      <div key={j} className={styles.feature}>
                        <div className={styles.iconContainer}>
                          <TickIcon className={styles.icon} />
                        </div>
                        <p className={styles.label}>{amenity}</p>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
        {getUpgradePackagesListData?.packages?.length > 0 && (
          <div className={styles.buttonContainer}>
            <button className={styles.button} onClick={upgradeHandler}>
              Upgrade
            </button>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

export default Upgrade;
